module.exports = __webpack_public_path__ + "static/media/bg-header-mobile.6b5ff5a0.svg";